import React from "react";

const Input = React.forwardRef(function Input(
    {
        leadingIcon = null,
        trailingIcon = null,
        className = "",
        invalid = false,
        type = "text",
        id,
        label,
        helperText,
        /** `sm`: shorter control (e.g. login). `md`: default. */
        size = "md",
        ...rest
    },
    ref,
) {
    const wrapper =
        "relative flex items-center rounded-xl border bg-white transition-colors focus-within:ring-2 focus-within:ring-brand-200 focus-within:border-brand-500";
    const stateBorder = invalid ? "border-danger-400" : "border-ink-200 hover:border-ink-300";

    const labelClass =
        size === "sm"
            ? "mb-1.5 block text-xs font-medium text-ink-700"
            : "mb-2 block text-sm font-medium text-ink-700";

    const inputSizeClass =
        size === "sm"
            ? "h-9 min-h-0 px-3 text-sm leading-snug text-ink-900 placeholder:text-ink-400 !min-h-0"
            : "px-4 py-3 text-base text-ink-900 placeholder:text-ink-400";

    return (
        <div className="w-full">
            {label && (
                <label htmlFor={id} className={labelClass}>
                    {label}
                </label>
            )}
            <div className={`${wrapper} ${stateBorder}`}>
                {leadingIcon && (
                    <span className="pl-3 text-ink-400" aria-hidden="true">
                        {leadingIcon}
                    </span>
                )}
                <input
                    ref={ref}
                    id={id}
                    type={type}
                    className={`block w-full border-0 bg-transparent shadow-none focus:outline-none focus:ring-0 ${inputSizeClass} ${
                        leadingIcon ? "pl-2" : ""
                    } ${trailingIcon ? "pr-2" : ""} ${className}`}
                    {...rest}
                />
                {trailingIcon && (
                    <span className="pr-3 text-ink-400" aria-hidden="true">
                        {trailingIcon}
                    </span>
                )}
            </div>
            {helperText && (
                <p className={`mt-1 text-xs ${invalid ? "text-danger-600" : "text-ink-500"}`}>
                    {helperText}
                </p>
            )}
        </div>
    );
});

export default Input;
